export const BUTTON_CONTAINER_HEIGHT = 72;
